module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    class: {
      pt170: _vm.headerStatus
    },
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "app-header",
    class: {
      active: !_vm.headerStatus
    }
  }, [_c('div', [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": ("/static/images/" + (_vm.headerStatus?'logo1':'logo') + ".png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header-nav"
  }, [_c('span', {
    class: {
      active: _vm.activeIndex == 1
    },
    on: {
      "click": function($event) {
        _vm.toUrl('/');
        _vm.activeIndex = 1
      }
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('span', {
    class: {
      active: _vm.activeIndex == 2
    },
    on: {
      "click": function($event) {
        _vm.toUrl('/shopkeeper');
        _vm.activeIndex = 2
      }
    }
  }, [_vm._v("成为店主")]), _vm._v(" "), _c('span', {
    class: {
      active: _vm.activeIndex == 3
    },
    on: {
      "click": function($event) {
        _vm.toUrl('/about');
        _vm.activeIndex = 3
      }
    }
  }, [_vm._v("关于美购")]), _vm._v(" "), _c('span', {
    class: {
      active: _vm.activeIndex == 4
    },
    on: {
      "click": function($event) {
        _vm.toUrl('/download');
        _vm.activeIndex = 4
      }
    }
  }, [_vm._v("APP下载")]), _vm._v(" "), _c('p', [_vm._v("客服热线：020-3992-1805")])])])]), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('div', {
    staticClass: "app-footer",
    class: {
      gray: _vm.activeIndex == 2
    }
  }, [_c('div', {
    staticClass: "setTop",
    on: {
      "click": function($event) {
        return _vm.setTop()
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.next_page),
      expression: "next_page"
    }],
    staticClass: "app-right-nav"
  }, [_c('div', {
    staticClass: "div"
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "div",
    on: {
      "click": function($event) {
        return _vm.setTop()
      }
    }
  })])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-box"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('img', {
    staticClass: "footer-logo",
    attrs: {
      "src": "/static/images/footer_logo.png?v=1.00",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "mt28 mb22 f20"
  }, [_vm._v("联系我们")]), _vm._v(" "), _c('p', {
    staticClass: "mb10"
  }, [_c('span', [_vm._v("客服电话: 020-3992-1805 ")]), _vm._v(" "), _c('span', {
    staticClass: "mr0"
  }, [_vm._v("招商热线: 020-3992-1805 ")])]), _vm._v(" "), _c('p', [_vm._v("地址:广州市番禺区番禺大道北555号天安节能科技园23号楼23层")])]), _vm._v(" "), _c('div', {
    staticClass: "code pull-right"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/public_number.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("美购国际公众号")])]), _vm._v(" "), _c('div', {
    staticClass: "code pull-right ml0"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/wechat.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("美购国际官方微信")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "record-number"
  }, [_c('a', {
    attrs: {
      "href": "https://beian.miit.gov.cn",
      "target": "_blank"
    }
  }, [_vm._v("粤ICP备18133614号-1")]), _vm._v("\n       COPYRIGHT 2018 MEGAOSHOP.COM ALL RIGHTS RESERVED. 美购国际 版权所有"), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "300px",
      "margin": "0 auto",
      "padding": "20px 0"
    }
  }, [_c('a', {
    staticStyle: {
      "display": "inline-block",
      "text-decoration": "none",
      "height": "20px",
      "line-height": "20px"
    },
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44011302002965"
    }
  }, [_c('img', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "src": "/static/images/record-logo.png"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "left",
      "height": "20px",
      "line-height": "20px",
      "margin": "0px 0px 0px 5px",
      "color": "#939393"
    }
  }, [_vm._v("粤公网安备 44011302002965号")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "div"
  }, [_c('div', {
    staticClass: "code"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('div', {
    staticClass: "img",
    staticStyle: {
      "background-image": "url('/static/images/public_number.png')"
    }
  }), _vm._v(" "), _c('p', [_vm._v("美购国际公众号")])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('div', {
    staticClass: "img",
    staticStyle: {
      "background-image": "url('/static/images/wechat.png')"
    }
  }), _vm._v(" "), _c('p', [_vm._v("美购国际官方微信")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-59547f58!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 578
// module chunks = 10